export const AUTO_NEXT_TRIGGER_PROGRESS = 99;
export const AUTO_NEXT_RESET_PROGRESS = 90;
export const WATCHED_COMPLETED_THRESHOLD = 92;
export const TOKEN_VALIDATION_INTERVAL_MS = 5 * 60 * 1000;
export const USE_CACHE_IF_AVAILABLE = true;
export const LIVE_STALL_RELOAD_COOLDOWN_MS = 12000;
